import './ForgotPasswordForm.scss';
import { Input } from '@components/Component/Field/Input/Input.js';
import { Form } from '@components/Component/Container/Form/Form.js';
import { Button } from '@components/Component/Button/Button.js';
import { DataRecord } from '@components/DataRecord/DataRecord.js';
import { getID } from '@components/Utility/index.js';
import DIContainer from '@components/DependencyInjectionContainer.js';
import { ScreenCover } from "@components/Component/Container/Screen/ScreenCover/ScreenCover.js";
/**
 * `ForgotPasswordForm` class that extends `Form`.
 * This class represents a forgot password page with input fields for userid and a submit button.
 */
export class ForgotPasswordForm extends Form {
    constructor(id, rootElement, dependencies = {}) {
        super(id, rootElement, dependencies);
        this.componentName = 'ForgotPasswordForm';
        this.loadExternalData = false;
    }
    initializeRecords() {
        this.record = new DataRecord(getID('ForgotPasswordForm'));
    }
    initializeComponents() {
        const userid = new Input('userid');
        userid.propertiesLoad({
            captionKey: 'login_userid',
            showLabel: true,
            largeField: true,
            labelPosition: 'top'
        });
        const submit = new Button('submit');
        submit.propertiesLoad({
            captionKey: 'login_resetinstructions',
            buttonSize: 'large'
        });
        const usernameCaption = this.getCaption('login_userid_placeholder');
        submit.before('click', () => {
            if (!this.record.get('userid')) {
                this.alert({ caption: this.getCaption('system_requiredfield_caption', { field: usernameCaption }), modalStyle: 'error' });
                return false;
            }
            return true;
        });
        submit.on('click', () => {
            this.sendEmail(submit);
        });
        // const caption = new Hint('caption')
        // caption.propertiesLoad({
        // 	captionKey: 'login_hint'
        // });
        // let forgotpassword = DIContainer.new<TextBase>('TextBase', 'forgotpassword');
        // forgotpassword.propertiesLoad({
        // 	captionKey: 'login_forgotpassword'
        // 	,textElementType: 'a'
        // 	,zoomTemplate: '/form/forgotpassword?userid={{userid}}'
        // 	//,textElementAttributes: {'href': '#'}
        // });
        const returntologin = DIContainer.new('TextBase', 'returntologin');
        returntologin.propertiesLoad({
            captionKey: 'system_login_auth_returntologin',
            textElementType: 'a',
            zoomTemplate: '#'
        });
        returntologin.on('click', (a) => {
            this.returnToLogin();
        });
        this.componentsAdd([
            userid,
            submit,
            returntologin
            //,caption
        ]);
    }
    /**
     * Executes sendEmail request to server NEED TO FIRE OFF AN EMAIL ANDS REDIRECT TO THE RESETPASSWORDFORM
     */
    sendEmail(initiator) {
        this.Request.POST({
            endpoint: 'authenticate',
            action: 'sendresetemail',
            loadingMessage: this.getCaption('system_loading_caption'),
            initiator: initiator,
            requestData: {
                userid: this.record.get('userid')
            }
        }).subscribe(() => {
            this.resetPassword();
        });
    }
    returnToLogin() {
        const screenManager = DIContainer.getInstance('ScreenManager');
        if (this.screenGet() instanceof ScreenCover) {
            screenManager.open(DIContainer.new('LoginFormOverlay'), {
                screenCover: true,
                requestParams: {
                    userid: this.record.get('userid')
                }
            });
        }
        else {
            this.navigate('/', {
                userid: this.record.get('userid')
            });
        }
    }
    resetPassword() {
        this.navigate('/form/resetpassword', {
            userid: this.record.get('userid')
        });
    }
    template() {
        return `<div class="form-cover"></div>
<div class="form-wrapper">

<div class="form-container">
<header>
	<span class="branding-logo"></span>
<span class="heading">${this.CaptionManager.getCaption('system_login_forgotpasswordheading')}</span>
<span class="sub-heading">${this.CaptionManager.getCaption('system_login_forgotpasswordsubheading')}</span>
</header>
		<form class="thin" >
			<div class="form-group">
				<span data-componentid="userid"></span>
			</div>
			<div class="form-group">
				<span data-componentid="submit"></span>
			</div>
			<div class="form-group">
				<div class="return-container">
					<span data-componentid="returntologin"></span>
				</div>
			</div>
		</form>
</div>
</div>`;
    }
}
ForgotPasswordForm.VERSION = '$Revision: 112885 $';
